import { lazy } from 'react';
import PATH from 'routes/paths';

const AccountingInternalRequestList = lazy(() =>
  import(
    'components/layout/mainPages/accountingPages/internalRequest/AccountingInternalRequestList'
  )
);

const AccountingInternalRequest = lazy(() =>
  import(
    'components/layout/mainPages/accountingPages/internalRequest/AccountingInternalRequest'
  )
);

// List route uses /internal-requests (exact), detail uses /internal-requests/:id (exact).
// No ordering conflict, but list first for consistency with the admin pattern.

const INTERNAL_REQUEST = {
  component: AccountingInternalRequest,
  path: PATH.INTERNAL_REQUEST.ONE,
  exact: true,
  isProtected: true,
};

const INTERNAL_REQUEST_LIST = {
  component: AccountingInternalRequestList,
  path: PATH.INTERNAL_REQUEST.LIST,
  exact: true,
  isProtected: true,
};

export default [INTERNAL_REQUEST_LIST, INTERNAL_REQUEST];
